import React, { useState } from 'react';

const LiveApplicationsCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const apps = [
    {
      name: 'BambooSA',
      imageUrl: '/assets/images/applications/bamboosa-logo.png',
      iosLink: 'https://apps.apple.com/in/app/bamboosa/id6502903278',
      androidLink: 'https://play.google.com/store/apps/details?id=com.bamboosa',
      websiteLink: 'https://bamboosa.online/',
    },
    {
      name: 'Muncheese',
      imageUrl: '/assets/images/applications/muncheese.png',
      iosLink: 'https://apps.apple.com/us/app/muncheese/id1564292290',
      androidLink: 'https://play.google.com/store/apps/details?id=com.muncheese.instaapp',
      websiteLink: 'https://www.muncheese.co.uk/',
    },
    {
      name: 'Madurai Mes',
      imageUrl: '/assets/images/applications/maduraimes.png',
      iosLink: 'https://apps.apple.com/us/app/madurai-mes/id1547975874',
      androidLink: 'https://play.google.com/store/apps/details?id=com.madhurai.restaurantapp',
      websiteLink: '',
    },
    {
      name: "Daddy's DS BBQ",
      imageUrl: '/assets/images/applications/Daddy_Ds_BBQ.png',
      iosLink: 'https://apps.apple.com/us/app/daddy-ds-bbq/id1618799180',
      androidLink: 'https://play.google.com/store/apps/details?id=com.daddydsbbq&hl=en&gl=US',
      websiteLink: '',
    },
    {
      name: "Potter’s Biryani",
      imageUrl: '/assets/images/applications/potter_logo.jpg',
      iosLink: 'https://apps.apple.com/us/app/potters-biryani/id6477150230',
      androidLink: 'https://play.google.com/store/apps/details?id=com.instaapp.pottersbiryani',
      websiteLink: '',
    },
    {
      name: 'Yashaswini Fresh',
      imageUrl: '/assets/images/applications/Yashaswini-Logo.png',
      iosLink: 'https://apps.apple.com/us/app/yashaswini-fresh/id6477534647',
      androidLink: 'https://play.google.com/store/apps/details?id=com.instaapp.yashaswinifresh',
      websiteLink: '',
    }
  ];

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % apps.length);
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + apps.length) % apps.length);
  };

  return (
    <section className="section-blue medium-paddings section-bottom-border padding-top-20">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h3 className="white-text">Our Live Applications...</h3>
          </div>
          <div className="col-md-8 mx-auto padding-bottom-40 bg-white">
            <div id="carouselIndicators2" className="carousel slide" data-ride="carousel">
              <ol className="carousel-indicators testimonials-indicators">
                {apps.map((app, index) => (
                  <li
                    key={index}
                    data-target="#carouselIndicators2"
                    data-slide-to={index}
                    className={index === activeIndex ? 'active' : ''}
                  ></li>
                ))}
              </ol>
              <div className="carousel-inner">
                {apps.map((app, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${index === activeIndex ? 'active' : ''}`}
                  >
                    <div className="testim-inner">
                      <img src={app.imageUrl} alt="applications" className="testim-img" />
                      <h3>{app.name}</h3>
                      <h6><a href={app.iosLink} target="_blank" rel="noopener noreferrer">iOS App</a></h6>
                      <h6><a href={app.androidLink} target="_blank" rel="noopener noreferrer">Android App</a></h6>
                      {app.websiteLink && <h6><a href={app.websiteLink} target="_blank" rel="noopener noreferrer">View Website</a></h6>}
                    </div>
                  </div>
                ))}
              </div>

              
              <a
                className="carousel-control-prev"
                href="#carouselIndicators2"
                role="button"
                data-slide="prev"
                onClick={handlePrev}
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
              </a>
              <a
                className="carousel-control-next"
                href="#carouselIndicators2"
                role="button"
                data-slide="next"
                onClick={handleNext}
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveApplicationsCarousel;


